import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './booking-pax.reducer';

export const BookingPaxDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bookingPaxEntity = useAppSelector(state => state.bookingPax.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bookingPaxDetailsHeading">
          <Translate contentKey="activitiesApp.bookingPax.detail.title">BookingPax</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{bookingPaxEntity.id}</dd>
          <dt>
            <span id="title">
              <Translate contentKey="activitiesApp.bookingPax.title">Title</Translate>
            </span>
          </dt>
          <dd>{bookingPaxEntity.title}</dd>
          <dt>
            <span id="firsName">
              <Translate contentKey="activitiesApp.bookingPax.firsName">Firs Name</Translate>
            </span>
          </dt>
          <dd>{bookingPaxEntity.firsName}</dd>
          <dt>
            <span id="lastName">
              <Translate contentKey="activitiesApp.bookingPax.lastName">Last Name</Translate>
            </span>
          </dt>
          <dd>{bookingPaxEntity.lastName}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="activitiesApp.bookingPax.email">Email</Translate>
            </span>
          </dt>
          <dd>{bookingPaxEntity.email}</dd>
          <dt>
            <span id="mobileNumber">
              <Translate contentKey="activitiesApp.bookingPax.mobileNumber">Mobile Number</Translate>
            </span>
          </dt>
          <dd>{bookingPaxEntity.mobileNumber}</dd>
          <dt>
            <span id="sprcialRequirements">
              <Translate contentKey="activitiesApp.bookingPax.sprcialRequirements">Sprcial Requirements</Translate>
            </span>
          </dt>
          <dd>{bookingPaxEntity.sprcialRequirements}</dd>
          <dt>
            <Translate contentKey="activitiesApp.bookingPax.booking">Booking</Translate>
          </dt>
          <dd>{bookingPaxEntity.bookingId ? bookingPaxEntity.booking.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/booking-pax" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/booking-pax/${bookingPaxEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BookingPaxDetail;
